import React from "react";
import BrandLogo from "./BrandLogo";

/**
 * PageHeader — shared top-of-page header used on every main route.
 * Shows the app icon (knya-icon.png) + "Knya" wordmark uniformly, matching the login page.
 */
export default function PageHeader({ eyebrow, title, subtitle, right, showLogo = true }) {
  return (
    <header className="px-5 pt-6 pb-3" data-testid="page-header">
      {showLogo && (
        <div className="flex items-center justify-between" data-testid="page-header-brand-row">
          <div className="flex items-center gap-2">
            <BrandLogo size={28} data-testid="page-header-brand-icon" />
            <span className="font-extrabold text-[15px] tracking-tight text-foreground" data-testid="page-header-brand-name">Knya</span>
          </div>
          {right && <div>{right}</div>}
        </div>
      )}
      <div className={`flex items-end justify-between gap-3 ${showLogo ? "mt-3" : ""}`}>
        <div className="min-w-0">
          {eyebrow && (
            <p className="text-[10px] uppercase tracking-wider text-primary font-extrabold">{eyebrow}</p>
          )}
          <h1 className="text-[36px] leading-[1.04] mt-2 font-extrabold tracking-tight text-foreground">{title}</h1>
          {subtitle && <p className="text-[13.5px] text-muted-foreground mt-2 font-medium">{subtitle}</p>}
        </div>
        {!showLogo && right}
      </div>
    </header>
  );
}
